import { render, staticRenderFns } from "./goTop.vue?vue&type=template&id=4acde9af&scoped=true"
import script from "./goTop.vue?vue&type=script&lang=js"
export * from "./goTop.vue?vue&type=script&lang=js"
import style0 from "./goTop.vue?vue&type=style&index=0&id=4acde9af&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acde9af",
  null
  
)

export default component.exports